/*
 * @Author: yzr
 * @Date: 2020-11-29 15:47:11
 * @LastEditors: yzr
 * @LastEditTime: 2020-11-30 15:15:45
 */
import TargetTable from './target_table.vue';

export default TargetTable;
